
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import regular from "@/common/regular";
import { purchasedRecordsAudit } from "@/api/api-basic-sms";
import uploadImage from "@/components/upload-image/upload-image.vue";
import showImg from "@/components/show-img/show-img.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-upload-image": uploadImage,
    "pi-show-img": showImg
  }
})
export default class MessageAuditMadel extends Vue {
  private modalShow = false;
  private loading = false;
  private modalTitle = i18n.t("messageRecord.msgAudit");
  private FormData: objAny = {};

  private ruleInline: objAny = {
    auditAction: [
      {
        required: true,
        type: "number",
        message: i18n.t("messageRecord.auditActionPl"),
        trigger: "change"
      }
    ],
    attachmentPkId: [
      {
        required: true,
        validator: this.regularFile,
        trigger: "change"
      }
    ]
  };
  private formItem: objAny = {
    auditAction: 1,
    attachmentPkId: "",
    remark: "",
    pkid: ""
  };
  private oprSystemLogoFilePath = "";
  private fileName = "";

  public regularFile(rule: objAny, value: string, callback: Function) {
    if (this.formItem.auditAction == 1 && value === "") {
      callback(new Error(i18n.t("messageRecord.oprSystemLogoFilePathPl") + ""));
    } else {
      callback();
    }
  }

  public open(item: objAny) {
    this.modalShow = true;
    this.formItem.auditAction = 1;
    this.formItem.remark = "";
    this.formItem.pkid = item.pkid;
    this.oprSystemLogoFilePath = "";
    this.fileName = "";
    this.formItem.attachmentPkId = "";
  }

  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  public handleSubmit() {
    const formItem: objAny = this.$refs.formItem;
    formItem.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    const ret = await purchasedRecordsAudit(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public uploadImg(data: objAny): void {
    this.oprSystemLogoFilePath = data.filePath;
    this.fileName = data.fileName;
    this.formItem.attachmentPkId = data.attachmentRecordPkId; //data.thumbnailFilePath;
  }
}
